export default "__VITE_ASSET___dj21YM5__"